import { API_URL_REGIONS } from "../config/env";

export async function fetchTradeData() {
	try {
		const response = await fetch(API_URL_REGIONS);
		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}

		const json = await response.json();

		return json ?? [];
	} catch (error) {
		console.error("Error fetching trade data:", error);
		return [];
	}
}

